import * as type from './actionTypesSagas';

export const loadPracticeExamInformation = (
  rate,
  rank,
  dutyState,
  practiceExamId,
) => ({
  type: type.LOAD_PRACTICE_EXAM_INFORMATION,
  rate,
  rank,
  dutyState,
  practiceExamId,
});

export const createPracticeExam = (examId, amountQuestions, examTime) => ({
  type: type.CREATE_PRACTICE_EXAM,
  examId,
  amountQuestions,
  examTime,
});

export const buildPracticeExam = (
  practiceExamId,
  amountQuestions,
  examTime,
) => ({
  type: type.BUILD_PRACTICE_EXAM,
  practiceExamId,
  amountQuestions,
  examTime,
});

export const checkBuildPEProgress = () => ({
  type: type.CHECK_BUILD_PE_PROGRESS,
});

export const removeQuestion = (practiceExamId, questionId) => ({
  type: type.REMOVE_QUESTION,
  practiceExamId,
  questionId,
});

export const activateExam = (practiceExamId) => ({
  type: type.ACTIVATE_EXAM,
  practiceExamId,
});

export const buildAllExams = (payload) => ({
  type: type.BUILD_ALL_EXAMS,
  payload,
});
